import { HistoryAction, HistoryActionKeys } from '../actions/history';
import { UiAction, UiActionKeys } from '../actions/ui';
import { ComboAction, ComboActionKeys } from '../actions/combo';
import { IndesignTextFieldsConfig } from '../utils/indesignEditor/editableTextFields/getData';
import { HtmlTextFieldsConfig } from '../utils/htmlEditor/editableTextFields/getData';
import { IndesignMediaElementConfig } from '../utils/indesignEditor/editableMedia/getData';
import { HtmlMediaElementConfig } from '../utils/htmlEditor/editableMedia/getData';
import { LinkConfig } from '../utils/editableLinks/getData';
import { ButtonConfig } from '../utils/indesignEditor/editableButtons/getData';
import { IframeConfig } from '../utils/indesignEditor/editableIframes/getData';
import { EnrichmentConfig } from '../utils/indesignEditor/editableEnrichments/getData';
import { SliderConfig } from '../utils/indesignEditor/editableSliders/getData';
import { BgStyleData } from './configs';

export enum Source {
	TEXT_FIELD = 'editableTextFields',
	MEDIA = 'editableMedia',
	LINK = 'editableLinks',
	BUTTON = 'editableButtons',
	IFRAME = 'editableIframes',
	ENRICHMENT = 'editableEnrichments',
	SLIDER = 'editableSliders',
	SPREAD_BACKGROUND = 'spreadBackground',
	CHANGE_SPREAD = 'changeSpread',
}

export interface UndoRedoTextFieldState {
	source: Source.TEXT_FIELD;
	data: IndesignTextFieldsConfig | HtmlTextFieldsConfig;
	page: number;
	id: string;
}

export interface UndoRedoMediaState {
	source: Source.MEDIA;
	data: IndesignMediaElementConfig | HtmlMediaElementConfig;
	page: number;
	id: string;
}

export interface UndoRedoLinkState {
	source: Source.LINK;
	data: LinkConfig;
	page: number;
	id: string;
}

export interface UndoRedoButtonState {
	source: Source.BUTTON;
	data: ButtonConfig;
	page: number;
	id: string;
}

export interface UndoRedoIframeState {
	source: Source.IFRAME;
	data: IframeConfig;
	page: number;
	id: string;
}

export interface UndoRedoEnrichmentState {
	source: Source.ENRICHMENT;
	data: EnrichmentConfig;
	page: number;
	id: string;
}

export interface UndoRedoSliderState {
	source: Source.SLIDER;
	data: SliderConfig;
	page: number;
	id: string;
}

export interface UndoRedoSpreadBackgroundState {
	source: Source.SPREAD_BACKGROUND;
	data: BgStyleData | {};
	page: number;
}

export interface ChangeSpreadData {
	currentSpreadIndex: number;
}

export interface UndoRedoChangeSpreadState {
	source: Source.CHANGE_SPREAD;
	data: ChangeSpreadData;
}

export type UndoRedoState = UndoRedoTextFieldState |
	UndoRedoMediaState |
	UndoRedoLinkState |
	UndoRedoButtonState |
	UndoRedoIframeState |
	UndoRedoEnrichmentState |
	UndoRedoSliderState |
	UndoRedoSpreadBackgroundState |
	UndoRedoChangeSpreadState;

export interface HistoryState {
	undos: UndoRedoState[];
	redos: UndoRedoState[];
}

const defaultState = [];

export const undos = (state: UndoRedoState[] = defaultState, action: HistoryAction | UiAction | ComboAction): UndoRedoState[] => {
	switch (action.type) {
		case HistoryActionKeys.UNDO:
			return state.slice(0, state.length - 1);
		case HistoryActionKeys.REDO:
			return [...state, action.item];
		case HistoryActionKeys.ADD_TO_UNDOS:
			return [...state, action.item];
		case UiActionKeys.RESET:
		case ComboActionKeys.FINISH_COMBO:
			return defaultState;
		default:
			return state;
	}
};

export const redos = (state: UndoRedoState[] = defaultState, action: HistoryAction | UiAction | ComboAction): UndoRedoState[] => {
	switch (action.type) {
		case HistoryActionKeys.UNDO:
			return [action.item, ...state];
		case HistoryActionKeys.REDO:
			return state.slice(1);
		case HistoryActionKeys.ADD_TO_UNDOS:
		case UiActionKeys.RESET:
		case ComboActionKeys.FINISH_COMBO:
			return defaultState;
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/reducer/history.ts